import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { debounceTime, Subject, Subscription } from 'rxjs';
@Component({
  selector: 'app-output-icons',
  templateUrl: './output-icons.component.html',
  styleUrls: ['./output-icons.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class OutputIconsComponent implements OnInit, OnChanges {
  @Output() iconClicked = new EventEmitter();
  @Input() widgetName = "";
  @Input() visualization = "";
  @Input() id: number = 0;
  @Input() data: any;
  @Input() infoIcon = "";
  @Input() sort = 0;
  @Input() item: any;
  @Input() isSort: any;
  @Input() trendData: any;
  @Input() sortToggleFromParent:any;

  private inputChanges = new Subject<any>();
  widgetExpand = false;
  inputPopup = false;
  infoTextTitle = '';
  infoTextMessage = '';
  star = false;
  disableInfo = false;
  showExpandPopup = false;
  showTrendPoppup = false;
  sortToggle = false;

  selectedOption = "Default";
  options: any = [
    { name: 'Default', isSelected: true },
    { name: 'Ascending', isSelected: false },
    { name: 'Descending', isSelected: false }
  ];
  private subscriptions: Subscription = new Subscription();
  constructor() {
  }
  ngOnInit() {
    //this.selectedOption = this.options.find(option => option.isSelected);
    // this.selectedOption = selectedOption ? selectedOption.name : 'default';
    
  }

  // options:{ name: string, isSelected: boolean }[]=[];
  // selectedOption: { name: string, isSelected: boolean }={ name: 'default', isSelected: true };
  ngOnChanges(changes: SimpleChanges) {
    this.inputChanges.next(changes);
    // this.inputChanges.pipe(debounceTime(300)).subscribe((debouncedChanges) => {
    //   if (debouncedChanges['sort'] || debouncedChanges['infoIcon']) {
    //     this.processData(debouncedChanges['sort'].currentValue, debouncedChanges['infoIcon'].currentValue);
    //   }
    // });
    if (changes['sort'] || changes['infoIcon']) {
      this.processData(changes['sort'].currentValue, changes['infoIcon'].currentValue);
    }

    if(changes['sortToggleFromParent']){
      this.selectedOption="Default";
    }
  }

  processData(sort: any, infoIcon: any) {  
    if (sort == 0) {
      this.sortToggle = false;
    }
    else if (sort == 1 && this.isSort == 0) {
      this.sortToggle = false;
    }
    else {
      this.sortToggle = true;
    }
    if (infoIcon == "") {
      this.disableInfo = true;
    }
    else {
      this.disableInfo = false;
    }
    this.defaultSortOnPagination()

  }
  @Output() defaultSortType = new EventEmitter();
  defaultSortOnPagination() {
    let tempItem = _.cloneDeep(this.item);
    for (let i = 0; i < tempItem.metric?.length; i++) {
      //tempItem = _.cloneDeep(this.item);
      tempItem.metric[i].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);

      
    }
    this.defaultSortType.emit(tempItem);
  }

  @Output() sortType = new EventEmitter();
  sortOption(event: Event): void {
    const selectedName = (event.target as HTMLSelectElement).value;
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].name == selectedName) {
        this.options[i].isSelected = true;
      }
      else {
        this.options[i].isSelected = false;
      }
    }

    let tempItem = _.cloneDeep(this.item);
    for (let i = 0; i < tempItem.metric.length; i++) {
      // Assuming dataObject is already defined as above

      // Sort the metrics array based on the data value
      if (selectedName == "Ascending") {
        tempItem.metric[i].metricSelected.metrics.sort((a: any, b: any) => {
          if (a.data.length > 0 && b.data.length > 0) {
            return a.data[0].data - b.data[0].data;
          }
          return 0; // If either array is empty, consider them equal
        });
      }
      else if (selectedName == "Descending") {
        tempItem.metric[i].metricSelected.metrics.sort((a: any, b: any) => {
          if (a.data.length > 0 && b.data.length > 0) {
            return b.data[0].data - a.data[0].data;
          }
          return 0; // If either array is empty, consider them equal
        });
      }
      else {
        //tempItem = _.cloneDeep(this.item);
        tempItem.metric[i].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);

      }

      
    }

    let data = {
      selectedName: selectedName,
      tempItem: tempItem
    }
    this.sortType.emit(data);
  }


  showInputPopup() {
    this.infoTextTitle = this.widgetName;
    this.infoTextMessage = this.infoIcon;
    if (this.infoTextMessage) {
      this.inputPopup = true;
    }
    else {
      this.inputPopup = false;
    }
    ;
    this.iconClicked.emit(this.inputPopup);
  }


  onCloseIconClick(data: any) {
    this.inputPopup = false;
    ;
  }
  starredIconClick() {
    this.star = !this.star;
    ;
  }

  showExpandPopupFun() {
    // this.widgetExpand=true;
    this.infoTextTitle = this.widgetName;
    
    this.showExpandPopup = true;
  }

  showTrendPopupFun() {
    this.infoTextTitle = this.widgetName;
    this.showTrendPoppup = true;
  }
  hide(data: any) {
    this.showTrendPoppup = data;
  }

  receivedDeleteConfirmation(data: any) {
    this.showExpandPopup = data;

  }
  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }

}
